import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { IAdminPermissions } from '../../feature/admin/models/permission';

// Using Ngrx Entities to address Performance issues in adding facilities.
export const AdminPermissionsAdapter = createEntityAdapter<IAdminPermissions>({
  selectId: (item: IAdminPermissions) => item.transactionId
});

export interface AdminPermissionsState extends EntityState<IAdminPermissions> {
  selectedPermissionId: number | null;
  isLoaded: boolean;
  serverError: boolean;
}

export const intialAdminPermissionsState: AdminPermissionsState = AdminPermissionsAdapter.getInitialState({
  selectedPermissionId: null,
  isLoaded: false,
  serverError: false
});

const {
  selectIds,
  selectEntities,
  selectAll
} = AdminPermissionsAdapter.getSelectors();

export const selectAdminPermissionsEntities = selectEntities;

export const selectAllAdminPermissionsEntities = selectAll;

export const selectAllAdminPermissionsIds = selectIds;

export const selectIsLoaded = (state: AdminPermissionsState) => state.isLoaded;

export const selectServerError = (state: AdminPermissionsState) => state.serverError;


